import * as Sentry from '@sentry/browser';

import { APP_VERSION, SENTRY_DSN } from './config';

let initialised = false;

/**
 * Browser Sentry init. Safe to call multiple times; no-op when DSN missing.
 * We deliberately turn off performance tracing - the in-store hardware is
 * limited and we only need exception reporting (§3.4).
 */
export function initSentry(): void {
  if (initialised) return;
  initialised = true;
  if (!SENTRY_DSN) return;
  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: APP_VERSION,
      tracesSampleRate: 0,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Sentry init failed', err);
  }
}

export function captureException(err: unknown, context?: Record<string, unknown>): void {
  if (context) {
    try {
      Sentry.setContext('app', context);
    } catch {
      /* ignore */
    }
  }
  try {
    Sentry.captureException(err);
  } catch {
    // never let observability break the app
  }
}
